import { apiFetch } from "../utils/apiFetch"

export function getSiteContent(page: string) {
  return apiFetch(`/api/site-content/${page}`) as Promise<Record<string, string>>
}

export function updateSiteContentEntry(key: string, value: string) {
  return apiFetch("/api/site-content", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ key, value })
  }) as Promise<{ key: string; value: string }>
}
